import axiosClient from "@/api/common/axiosClient.ts";
import { PaginatedResponse } from "@/api/types.ts";
import { Ticket } from "@/types/ticket.ts";

export const getTickets = () => {
  return axiosClient.get<PaginatedResponse<Ticket>>("/tickets/me/");
};
